import { RichTextInputController } from './rich-text-input.controller'

const component = {
  templateUrl: '/workflow/components/rich-text-input/rich-text-input.html?$$REVISION$$',
  bindings: {
    field: '<',
    readOnly: '<',
    variations: '<', // space-delimited
    onChange: '&'
  },
  controllerAs: '$ctrl',
  controller: RichTextInputController
}

export const richTextInput = component
